import { render, staticRenderFns } from "./bind-active.vue?vue&type=template&id=332eaa7e&scoped=true&"
import script from "./bind-active.vue?vue&type=script&lang=js&"
export * from "./bind-active.vue?vue&type=script&lang=js&"
import style0 from "./bind-active.vue?vue&type=style&index=0&id=332eaa7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332eaa7e",
  null
  
)

export default component.exports